export enum ModuleKind {
  Agents = "agents",
  Files = "files",
  CaseManagement = "case_management",
  Connect = "connect",
  History = "history",
}

export const MODULE_KIND_DISPLAY_NAMES: Record<ModuleKind, string> = {
  [ModuleKind.Agents]: "Agents",
  [ModuleKind.Files]: "Files",
  [ModuleKind.CaseManagement]: "Case Management",
  [ModuleKind.Connect]: "Connect",
  [ModuleKind.History]: "History",
};
